module.exports = __webpack_public_path__ + "static/media/team2.a96adc27.jpg";